$(()=> {
  let selectDepartment = $('#select-department');
  let selectProvince = $('#select-province');
  let selectDistrict = $('#select-district');

  function selectCustom(el, bool) {
    el.attr('disabled', !bool);
    el.css('opacity', (!bool) ? '0.5' : '1');
    // el.parent().addClass( (!bool) ? '' : 'disabled' );
  }

  selectCustom(selectDepartment, false);
  selectCustom(selectProvince, false);
  selectCustom(selectDistrict, false);


  const listDepartment = async () => {
    try {
      let data = await (await fetch('/ubigeos')).json();

      for ( let elem of data ) {
        selectDepartment.append($('<option />').val(elem.id).text(elem.name));
      }

      selectCustom(selectDepartment, true);

    } catch (error) {
      console.error('error: ', error);
    }
  }

  listDepartment();

  const listProvince = async (e) => {
    let el = $(e.currentTarget);
    let id = el.val();

    $('option:gt(0)', selectProvince).remove();

    try {
      let data = await (await fetch('/ubigeos/' + id)).json();

      for ( let elem of data ) {
        selectProvince.append($('<option />').val(elem.id).text(elem.name));
      }

      selectCustom(selectProvince, true);

    } catch (error) {
      console.error('error: ', error);
    }
  }

  selectDepartment.on('change', listProvince);

  const listDistrict = async (e) => {
    let el = $(e.currentTarget);
    let id = el.val();

    $('option:gt(0)', selectDistrict).remove();

    try {
      let data = await (await fetch('/ubigeos/' + id)).json();

      for ( let elem of data ) {
        selectDistrict.append($('<option />').val(elem.id).text(elem.name));
      }

      selectCustom(selectDistrict, true);

    } catch (error) {
      console.error('error: ', error);
    }
  }

  selectProvince.on('change', listDistrict);
});
